import React from 'react'
import { FiArrowRightCircle } from 'react-icons/fi'
import { IoMdCheckmark } from "react-icons/io";
import { RxCross2 } from "react-icons/rx";

const features = [
  {
    feature: "Training Certificate in collaboration with E-Cell IIT Hyderabad",
    selfPaced: true,
    mentorLed: true
  },
  {
    feature: "Internship Certificate with our Co-Partnered Company",
    selfPaced: true,
    mentorLed: true
  },
  {
    feature: "1 Minor + 1 Major project",
    selfPaced: true,
    mentorLed: true
  },
  {
    feature: "25+ Hours of video content access",
    selfPaced: true,
    mentorLed: true
  },
  {
    feature: "16+ Hours of mentor live training",
    selfPaced: false,
    mentorLed: true
  },
  {
    feature: "10+ Hours of Live Skill Development Sessions",
    selfPaced: false,
    mentorLed: true
  },
  {
    feature: "Letter Of Recommendation Based on Performance",
    selfPaced: false,
    mentorLed: true
  },
  {
    feature: "Outstanding Certificate for Exceptional Performance in Projects",
    selfPaced: false,
    mentorLed: true
  }
];

function Font_page() {
  return (
    <div className="px-5 my-5 py-5 background_color">
      <div className="container-fluid mt-5">
        <table className=''>
          {/* -------------------top Bar-------------- */}
          <thead className="totals">
            <tr>
              <th colSpan="8" className="text-center">
                <div className="header">
                  <div className="text-center Certificates_text">
                    <h1 className="display-6 pb-2">
                      Android App Development Course Fee
                    </h1>
                    <p className="">
                      Choose from our different pricing plans for our Android
                      App Development.
                    </p>
                  </div>
                </div>
              </th>
            </tr>
          </thead>

          {/* -----------------------------header----------------------- */}
          <thead className="Header_bar">
            <tr className=''>
              <th className="text-center"></th>
              <th className="text-center">Self Paced Program</th>
              <th className="text-center">Mentor Led Program</th>
            </tr>
          </thead>

          {/* -------------------------content-------------------- */}
          <tbody>
            {features.map((item, index) => (
              <tr key={index}>
                <td className="">
                  <FiArrowRightCircle size="20px" color="#00FF00" /> {item.feature}
                </td>
                <td className="text-center">
                  {item.selfPaced ? <IoMdCheckmark size="20px" color="#00FF00" /> : <RxCross2 size="20px" color="#00FF00" />}
                </td>
                <td className="text-center">
                  {item.mentorLed ? <IoMdCheckmark size="20px" color="#00FF00" /> : <RxCross2 size="20px" color="#00FF00" />}
                </td>
              </tr>
            ))}
          </tbody>

          <thead className="Header_bar">
            <tr>
              <th className="text-center">Price:</th>
              <th className="text-center">₹4,999 /-</th>
              <th className="text-center">₹7,999 /-</th>
            </tr>
          </thead>
          <thead className="Header_bar">
            <tr>
              <th className="text-center"></th>
              <th className="text-center">
                <div className='text-center py-3'>
                  <a href='https://payments.internselite.net/traineeship/T7?method=sp'>
                    <button className="shadow-sm mx-4 px-5 pt-2 pb-2 Navbar_button">Buy Now</button>
                  </a>
                </div>
              </th>
              <th className="text-center">
                <div className='text-center py-3'>
                  <a href='https://payments.internselite.net/traineeship/T7?method=sp'>
                    <button className="shadow-sm mx-4 px-5 pt-2 pb-2 Navbar_button">Buy Now</button>
                  </a>
                </div>
              </th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  )
}

export default Font_page
